// extracted by mini-css-extract-plugin
module.exports = {"container":"KeyMetrics_container__3HQMS","table":"KeyMetrics_table__2EQzU","metricRow":"KeyMetrics_metricRow__S1vKr","title":"KeyMetrics_title__38kqF"};